(async () => {

  if (!customElements.get('product-card-swiper')) {

    const Swiper = (await import('swiper')).default;
    const { Autoplay, Navigation, Pagination, Scrollbar } = await import('swiper/modules');

    // Modules are now included in the Swiper constructor options

    class ProductCard extends HTMLElement {
      constructor() {
        super();

        let windowWidth = window.innerWidth;
        this.swiperElement = this.querySelector('[data-swiper-product-card]');

        this.swiperOptions = {
          modules: [Navigation, Pagination, Scrollbar, Autoplay],
          watchOverflow: true,
          preventClicks: true,
          loop: false,
          autoplay: false,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          },
          slidesPerView: 1,
          direction: 'horizontal'
        }

        // Check if we have extra options on the HTML
        if (this && this.dataset && this.dataset.options) {
          const jsonOptions = JSON.parse(this.dataset.options);

          if (jsonOptions) {
            this.swiperOptions = {
              ...this.swiperOptions,
              ...jsonOptions
            };
          }
        }

        window.addEventListener('load', () => {
          if (windowWidth < 768) {
            this.init();
            this.querySelectorAll('button').forEach(button => button.classList.remove('hidden'));
          } else if(this.swiperInstance) {
            this.querySelectorAll('button').forEach(button => button.classList.add('hidden'));
          }
        });

        window.addEventListener('resize', () => {
          windowWidth = window.innerWidth;
          if (windowWidth < 768) {
            this.init();
            this.querySelectorAll('button').forEach(button => button.classList.remove('hidden'));
          } else if(this.swiperInstance) {
            this.querySelectorAll('button').forEach(button => button.classList.add('hidden'));
          }
        });
      }

      init() {
        this.swiperInstance = new Swiper(this.swiperElement, this.swiperOptions);
      }
    }

    window.ProductCard = ProductCard;

    customElements.define('product-card-swiper', ProductCard);

  }

})();
